import * as actions from './updateAddressActions';
import { capitalize } from '../../../lib/helpers';

const updateAddressReducers = {
  [actions.USER_UPDATE_ADDRESS_SUCCESS_RECEIVED]: (state, { payload }) => {
    state.addresses['mailing'] = {
      ...payload,
      streetAddress: capitalize(payload.streetAddress),
      city: capitalize(payload.city),
    };
    return state;
  },
};

export default updateAddressReducers;
